// extracted by mini-css-extract-plugin
export default {"banner":"SettingsBanner_banner__mfv8H","checkmarkIcon":"SettingsBanner_checkmarkIcon__bHnmZ","primaryAsset":"SettingsBanner_primaryAsset__pR9nT"};